import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ReadyToWearImg from "../../../assets/images/image/clothes/ready-to-wear-img.webp";
import DiscoverImg from "../../../assets/images/image/scarves.webp";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  max-width: 100%;
  height: auto;
  /* border: 1px solid ${colors.line}; */
  /* padding: 32px 40px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 40px 20px;
`;

const Columns = styled.div``;

const Line = styled.span`
  width: 20%;
  height: 1px;
  /* margin: auto; */
  background-color: ${colors.secondaryGray};
`;

const List = styled.ul`
  display: flex;
  gap: 20px;
  padding-left: 0;
  max-width: 180px;
  flex-direction: column;
  span {
    color: ${colors.black};
    letter-spacing: 0.12rem;
    font-size: ${fontSize.s};
    line-height: 1.2rem;
  }

  li {
    padding: 0;
    list-style: none;
    cursor: pointer;
    letter-spacing: 0.08rem;
    font-size: ${fontSize.xxs};
    color: ${colors.primaryGray};
    &:hover {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 4;
  overflow: hidden;
  flex-shrink: 0;
  padding-top: 10px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
`;

const Title = styled.span`
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-size: ${fontSize.m};
  color: #fff;
  z-index: 12;
`;

function ClothingMegaMenu() {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Container>
        <Columns>
          <List>
            <span>COLLECTIONS</span>
            <li>Langtang Collection - Coming Soon</li>
            <li
              onClick={() => (window.location.href = `/browse?category=wool`)}
            >
              Sheep Wool
            </li>
            <li
              onClick={() =>
                (window.location.href = `/browse?category=pashmina`)
              }
            >
              Pashmina
            </li>
            <li
              onClick={() =>
                (window.location.href = `/browse?category=cashmere`)
              }
            >
              Cashmere
            </li>
          </List>
        </Columns>
        <Line />
        <Columns>
          <List>
            <span>CLOTHING</span>
            <li
              onClick={() =>
                (window.location.href = `/browse?category=coatAndJackets`)
              }
            >
              Coats & Jackets
            </li>

            <li
              onClick={() =>
                (window.location.href = `/browse?category=knitwear`)
              }
            >
              Knitwear
            </li>
            <li
              onClick={() =>
                (window.location.href = `/browse?category=trousers`)
              }
            >
              Trousers
            </li>
            <li onClick={() => (window.location.href = `/browse?category=all`)}>
              All Ready to wear
            </li>
          </List>
        </Columns>
        <Line />
        <Columns>
          <List>
            <span>ACCESSORIES</span>
            <li
              onClick={() => (window.location.href = `/browse?category=hats`)}
            >
              Hats & Beanies
            </li>
            <li
              onClick={() =>
                (window.location.href = `/browse?category=accessories`)
              }
            >
              Gloves
            </li>
            <li
              onClick={() => (window.location.href = `/browse?category=robe`)}
            >
              Robe
            </li>
            <li
              onClick={() => (window.location.href = `/browse?category=shawl`)}
            >
              Shawls & Scarfs
            </li>
          </List>
        </Columns>
        <Line />
      </Container>
      <CardWrapper>
        <Card
          onClick={() => {
            window.location.href = "/browse?category=shawl";
          }}
        >
          <ImageWrapper>
            <img src={DiscoverImg} alt="end of season" />
            <Title>SCARVES</Title>
          </ImageWrapper>
        </Card>
        <Card
          onClick={() => {
            window.location.href = "/browse";
          }}
        >
          <ImageWrapper>
            <img src={ReadyToWearImg} alt="ready to wear" />
            <Title>READY TO WEAR</Title>
          </ImageWrapper>
        </Card>
      </CardWrapper>
    </Wrapper>
  );
}

export default ClothingMegaMenu;
